export default __webpack_public_path__ + "static/media/monkey7.4a40f5cd.JPG";